const domain = () => {
  let host: string = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  return host.split('.').slice(-2).join('.');
};

let amaModulesCache: any = null;


export default function getModules() {
  if (amaModulesCache) {
    return amaModulesCache;
  }

  amaModulesCache = {
    useStats: true,
    useLimitedAds: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    useFirstWaveBatching: false,
    useSingleRequest: false,
    usePrebidVideo: true,
    useLoadDmByAdsLib: true,
    adTags:{},
    useContentUpdatedEvent: true,
    useSecondArticle: true,
  }; 

  return amaModulesCache;
}
